export default class Option<T>{
	public value: T = null;
	public text: string = "";
	public disabled: boolean = false;
}